import {
  Button,
  Card,
  CardBody,
  Checkbox,
  FormControl,
  HStack,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from '@chakra-ui/react';
import { AxiosError } from 'axios';
import { useState } from 'react';
import { MdInfoOutline } from 'react-icons/md';
import { toast } from 'react-toastify';
import { disableContract } from 'services/contract';
import { Contract } from 'shared/models/contract';

export interface ModalOutputValue {
  stt: boolean;
  msg: string;
}
interface DisableContractModalProps {
  isOpen: boolean;
  onClose(outputValue?: ModalOutputValue): void;
  contract: Contract;
}

const DisableContractModal: React.FC<DisableContractModalProps> = ({
  isOpen,
  onClose: onCloseFromProps,
  contract,
}) => {
  const [loading, setLoading] = useState(false);

  const [shouldCancelAllOpenOrders, setShouldCancelAllOpenOrders] =
    useState(false);

  const onClose = (outputValue?: ModalOutputValue) => {
    onCloseFromProps(outputValue);
    setLoading(false);
  };

  const submit = () => {
    disableContract(contract.id as number, shouldCancelAllOpenOrders)
      .then(() => {
        onClose({ stt: true, msg: 'Contrato desativado com sucesso' });
      })
      .catch((e: AxiosError) => {
        toast.error('Não foi possível desativar o contrato');
        console.error(
          'Não foi possível desativar o contrato',
          e?.response?.data
            ? JSON.stringify(e?.response?.data, null, 2)
            : JSON.stringify(e?.response, null, 2),
        );
        onClose({ stt: false, msg: 'Não foi possível desativar o contrato' });
      });
  };

  return (
    <Modal
      closeOnOverlayClick={!loading}
      closeOnEsc={!loading}
      isOpen={isOpen}
      onClose={() => onClose()}
      size="md"
    >
      <ModalOverlay />

      <ModalContent>
        <ModalCloseButton isDisabled={loading} />
        <ModalHeader>
          Desativar contrato {contract.selectedPeriodicity}
        </ModalHeader>

        <ModalBody>
          <FormControl mt="1rem">
            <Stack spacing={1}>
              <Checkbox
                isDisabled={loading}
                onChange={() => setShouldCancelAllOpenOrders(true)}
              >
                Cancelar todas as cobranças abertas?
              </Checkbox>
            </Stack>
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Stack w="100%">
            {shouldCancelAllOpenOrders === true && (
              <Card bg="blue.100">
                <CardBody>
                  <HStack gap="1rem">
                    <Icon as={MdInfoOutline} color="blue.500" />
                    <Text fontSize="0.9rem" fontWeight="400" color="gray.600">
                      Todos os boletos faturados serão cancelados.
                    </Text>
                  </HStack>
                </CardBody>
              </Card>
            )}
            <Button
              isLoading={loading}
              onClick={submit}
              colorScheme="yooga"
              w="100%"
            >
              Confirmar
            </Button>
          </Stack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DisableContractModal;
